export const createChargingPoint = async (payload) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint`

        const api = await fetch(url, {
            method: 'POST',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify(payload),
        })

        const response = await api.json()

        return response
    } catch (error) {
        console.log('Could not create location', error);
    }
}

export const updateChargingPoint = async ({ chargingpointUuid, payload }) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingpointUuid}`

        const api = await fetch(url, {
            method: 'PUT',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })

        return await api.json()
    } catch (error) {
        console.log('Could not update charging point', error)
    }
}

export const patchChargingPoint = async ({ chargingpointUuid, payload }) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingpointUuid}`

        const formData = new FormData()
        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value)
        })

        const api = await fetch(url, {
            method: 'PATCH',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: formData,
        })

        const response = await api.json()
        return response.chargingpoint
    } catch (error) {
        console.log('Could not update charging point', error)
    }
}

export const getChargingpointByPolygon = async (polygon, opts = {}) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoints/coordinates/polygon`
        const payload = {
            coordinates: polygon,
        }
        if (opts.pageSize != null) payload.pageSize = opts.pageSize
        if (opts.status) payload.status = opts.status
        if (opts.format) payload.format = opts.format

        const api = await fetch(url, {
            method: 'POST',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })

        let data = null
        try {
            data = await api.json()
        } catch (error) {
            data = null
        }

        return {
            status: api.status,
            ok: api.ok,
            data,
        }
    } catch (error) {
        console.log('Could not fetch charging points by polygon', error)
    }
}